// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"488":"c17b32dd7302918bfd2dca3f45b31e6b92daa58a","691":"component---src-pages-index-tsx","722":"component---src-pages-s-tsx","883":"component---src-pages-404-js"}[chunkId] + "-" + {"488":"cb22d4df58278ec58b82","691":"bb70cb9ad4b4649efc7c","722":"86f3d609e7fc045f5a89","883":"64b8f30b02e5feea7a38"}[chunkId] + ".js";
};